export function normalizeSollioRuleName(value) {
  const normalized = String(value || "")
    .trim()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");
  return normalized.endsWith(" inc") ? normalized.slice(0, -4).trim() : normalized;
}

function deduplicateAliases(aliases) {
  const seen = new Set();
  return aliases.reduce((result, alias) => {
    const trimmedAlias = String(alias || "").trim();
    const lookupKey = normalizeSollioRuleName(trimmedAlias);
    if (!lookupKey || seen.has(lookupKey)) {
      return result;
    }
    seen.add(lookupKey);
    result.push(trimmedAlias);
    return result;
  }, []);
}

export function buildSollioRuleAliasesForUpdate(rule, nextName) {
  const previousPrimaryKey = normalizeSollioRuleName(rule?.label);
  const historicalAliases = Array.isArray(rule?.aliases)
    ? rule.aliases.filter((alias) => normalizeSollioRuleName(alias) !== previousPrimaryKey)
    : [];
  return deduplicateAliases([nextName, ...historicalAliases]);
}
